import React from "react";
import InputMask from "react-input-mask";
import TextField from "@mui/material/TextField";
import "../pages/Myaccount/Myaccount.css";

const MaskedTextField = ({
  mask,
  placeholder,
  value,
  onChange,
  className="form-control text-feild-custom mx-2",
}) => {   
  return (
    <InputMask
      mask={mask}
      className={className}
      sx={{
        "& legend": { display: "none" },
        "& fieldset": { top: 0 },
      }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required
      type="text"
      placeholder={placeholder}
      size="small"
      style={{minWidth:'300px'}}
    >
      {(inputProps) => <TextField {...inputProps} />}
    </InputMask>
  );
};

export default MaskedTextField;
